const PO_TEXT = 'po'
const MAIL_TEXT = 'mail'

// Note to intrepid and well-meaning future developers!
//
// The following crusty list is the subject of many silly email chains. It has been discussed at great length
// by a lot of people. It is well-known that it is strange and arbitrary. The eventual intent is to make this
// sort of blacklist retrievable from a better system of record than a constants file locked inside the our
// front end build. However, please also realize that it shouldn't be mucked about with arbitrarily unless you
// really feel like poking bears.
//
const INVALID_ADDRESS = [
  'PO',
  'P.O.',
  'P.O.B.',
  'PO Box',
  'P.O. Box',
  'PO BOX',
  'POBOX',
  'P O BOX',
  'P. O. BOX',
  'P.O.BOX',
  'P.O. BOX',
  'P O Box',
  'P O BOC',
  'CALLER',
  'CALL BOX',
  'GPO BOX',
  'PO BOXS-',
  'BOX',
  'BUZON', // This is Spanish for "mailbox", by the way.
  'PMB',
  'Post Office Box',
  'Bx',
  'Box',
  'po box',
  'Postal Office',
  'Mail',
  'Mailbox',
  '--Mailbox',
  'Mail-box',
]

export const PO_TEXT_RESTRICTION_PATTERN =
  /^po[a-zA-Z]{1}.*$|^.*[a-zA-Z]{1}po$|^.*[a-zA-Z]{1}po[a-zA-Z]{1}.*$/
export const MAIL_TEXT_RESTRICTION_PATTERN =
  /^mail[a-zA-Z]{1}.*$|^.*[a-zA-Z]{1}mail$|^.*[a-zA-Z]{1}mail[a-zA-Z]{1}.*$/

export const isPoBox = (val: string): boolean => {
  const normalizedValue = val.trim().toLowerCase()

  const match = INVALID_ADDRESS.find((item: string) => {
    return (
      ` ${normalizedValue.trim().toLowerCase()} `.search(
        ` ${item.toLowerCase()} `,
      ) !== -1
    )
  })

  return (
    !!match ||
    !!normalizedValue.split(' ').find((item: string) => {
      return (
        (item.indexOf(PO_TEXT) !== -1 &&
          !PO_TEXT_RESTRICTION_PATTERN.test(item)) ||
        (item.indexOf(MAIL_TEXT) !== -1 &&
          !MAIL_TEXT_RESTRICTION_PATTERN.test(item))
      )
    })
  )
}
